import React, { Component } from 'react';
import { toast } from '../../utilities/appToast';
import { formatoDecimal } from '../../utilities/formatoNumeros'
import { getLogoPlataformaById, getLabelEstadoById, idEstadosOrden, normalizeIdEstadoOrden } from "../../helper/ordenHelper";
import PropTypes from 'prop-types';

const PLACEHOLDER_PRODUCTO_IMG =
    'https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png';

const resolveProductImageSrc = (src) => {
    const value = src != null ? String(src).trim() : '';
    return value || PLACEHOLDER_PRODUCTO_IMG;
};

export default class OrdenListItem extends Component {
    copyAlPortapapeles = async (e, valor, etiqueta) => {
        e.stopPropagation();
        if (valor === undefined || valor === null || valor === '') return;
        try {
            await navigator.clipboard.writeText(String(valor));
            toast.success(`${etiqueta} copiado`);
        } catch {
            toast.error('No se pudo copiar al portapapeles');
        }
    };

    copyTargetKeyDown = (e, valor, etiqueta) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.copyAlPortapapeles(e, valor, etiqueta);
        }
    };

    /** span + role="button": evita button anidado cuando la fila padre es un botón (p. ej. ListOrdenes). */
    renderCopyControl = (valor, etiqueta, children, className, title) => (
        <span
            role="button"
            className={className}
            title={title}
            tabIndex={0}
            onClick={(e) => this.copyAlPortapapeles(e, valor, etiqueta)}
            onKeyDown={(e) => this.copyTargetKeyDown(e, valor, etiqueta)}
            style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
        >
            {children}
        </span>
    );

    render = () => {
        const {
            idOrden,
            idReferencia,
            seller,
            fecha,
            cliente,
            estado,
            tipoEntrega,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            showComision,
            importeComision,
            anulacionMegatone
        } = this.props;
        const changeTipoEntrega = (tipoEntrega) => {
            if (!tipoEntrega) return;
            return (tipoEntrega.includes("sucursal correo")) ? "Env\u00CDo a domicilio" : tipoEntrega;
        }

        const reversoVisible = idReferencia !== undefined
            && idReferencia !== null
            && String(idReferencia).trim() !== ''
            && String(idReferencia).trim() !== '0';

        const ordenAnulada =
            anulacionMegatone?.anulado === true ||
            (Array.isArray(estado) && estado.some((e) => normalizeIdEstadoOrden(e.idEstado) === idEstadosOrden.anulado));
        const idEstadoBadge = ordenAnulada ? idEstadosOrden.anulado : normalizeIdEstadoOrden(estado?.[0]?.idEstado) ?? estado?.[0]?.idEstado;

        const cardEstadoClass =
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.anulado ? 'orden-card-estado-anulada' :
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.facturado ? 'orden-card-estado-facturada' :
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.pendiente ? 'orden-card-estado-pendiente' : '';

        const logoPlataforma = getLogoPlataformaById(plataformaCodigo);

        return (
            <div
                className={`w-100 list-group-item hover-background-color orden-card-por-estado ${cardEstadoClass}`.trim()}
                style={{ margin: 0 }}
            >
                <div className="row align-items-center text-center text-break">
                    <div className="col-12 col-md-2 d-flex flex-column align-items-center">
                        <h6 className="font-weight-bold">{seller}</h6>
                        <span className="d-block font-size-072rem">{fecha?.slice(0, 10)}</span>
                        <span className="d-block font-size-072rem mt-1">Id orden</span>
                        {this.renderCopyControl(idOrden, 'N° orden', idOrden, 'd-block font-size-072rem orden-copy-id', 'Clic para copiar N° orden')}
                        {reversoVisible && (
                            <>
                                <span className="d-block font-size-072rem mt-1">Reverso</span>
                                {this.renderCopyControl(idReferencia, 'Reverso', idReferencia, 'd-block font-size-072rem orden-copy-id', 'Clic para copiar reverso')}
                            </>
                        )}
                    </div>
                    <div className="col-12 col-md-2">
                        <small className="font-14 font-weight-bold applyFont d-block my-1">{cliente}</small>
                        <small hidden={!mailCliente || mailCliente.length < 1} className="applyFont d-block my-1">{mailCliente}</small>
                        {logoPlataforma ? (
                            <img src={logoPlataforma} alt="" style={{ width: "50px" }} className="my-1" />
                        ) : null}
                        <small className="d-block fw-bold mt-1">{dniIdBocaSeller != 0 ? dniIdBocaSeller : ""}</small>
                    </div>
                    <div className="col-12 col-md-5">
                        {Array.isArray(productos) && productos.map((producto, i, { length }) => (
                            <div className="row align-items-center justify-content-center" key={`${producto.sellerSku}${i}`}>
                                <div className="col-12 col-md-3">
                                    <img
                                        alt="user-img"
                                        className="mw-60px img-responsive"
                                        src={resolveProductImageSrc(producto.imagenPrincipal)}
                                    />
                                </div>
                                <div className="col-md-9">
                                    <h6 className="box-title m-b-5 font-weight-bold">
                                        <small className="applyFont">{producto.cantidad}x </small>
                                        {this.renderCopyControl(producto.titulo, 'Nombre del producto', producto.titulo, 'applyFont orden-copy-id', 'Clic para copiar nombre del producto')}
                                    </h6>
                                    <small className="applyFont d-block">
                                        Precio unitario:
                                        {" "}
                                        {this.renderCopyControl(producto.precioUnitario, 'Precio unitario', `$${formatoDecimal(producto.precioUnitario)}`, 'applyFont orden-copy-id', 'Clic para copiar precio unitario')}
                                    </small>
                                    <small className="applyFont d-block">
                                        SKU Seller:
                                        {" "}
                                        {this.renderCopyControl(producto.sellerSku, 'SKU seller', producto.sellerSku, 'applyFont orden-copy-id', 'Clic para copiar SKU seller')}
                                    </small>
                                    <small className="applyFont d-block">
                                        SKU Market:
                                        {" "}
                                        {this.renderCopyControl(producto.skuMarket, 'SKU market', producto.skuMarket, 'applyFont orden-copy-id', 'Clic para copiar SKU market')}
                                    </small>
                                </div>
                                <div className="col-9 col-md-10 border-bottom" hidden={i + 1 === length} />
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="row">
                            <div className="col-12 col-xxl-7">
                                <h5 className="font-weight-bold box-title d-block">${formatoDecimal(montoVenta)}</h5>
                                <br />
                                {showComision && <h5 className="box-title d-block">${formatoDecimal(importeComision)}</h5>}
                            </div>
                            <div className="col-12 col-xxl-5 orden-estado-label-wrap px-1">
                                <span className={`label label-${getLabelEstadoById(idEstadoBadge).color} orden-estado-label`}>
                                    {getLabelEstadoById(idEstadoBadge).label}
                                </span>
                                <small className="d-block my-1">{changeTipoEntrega(tipoEntrega)}</small>
                                {ordenAnulada && anulacionMegatone?.motivoAnulacion ? (
                                    <small className="d-block my-1">{anulacionMegatone.motivoAnulacion}</small>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
OrdenListItem.propTypes = {
    idOrden: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idReferencia: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    seller: PropTypes.string,
    fecha: PropTypes.string,
    cliente: PropTypes.string,
    estado: PropTypes.arrayOf(PropTypes.shape({
        idEstado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })),
    tipoEntrega: PropTypes.string,
    montoVenta: PropTypes.number,
    productos: PropTypes.array,
    mailCliente: PropTypes.string,
    dniIdBocaSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    plataformaCodigo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showComision: PropTypes.bool,
    importeComision: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    anulacionMegatone: PropTypes.shape({
        anulado: PropTypes.bool,
        motivoAnulacion: PropTypes.string,
    }),
}